var $plp = {
  filter_option: '.plp-filter-checkbox-container'
};

$(document).ready(() => {
  listeners();
});

function listeners() {
  $(document).on('click', $plp.filter_option, function(){
    $('form.plp-filters-form').submit();
  });
  // Filter/Sort Triggers
  $(document).on('click', '.fs-filter-trigger', function(){
    $('.collection-filters-column, .collection-filters-column-mobile-overlay').addClass('active');
  });
  $(document).on('click', '.fs-filter-close-trigger', function(){
    $('.collection-filters-column, .collection-filters-column-mobile-overlay').removeClass('active');
  });
}
